import * as requestFromServer from "./userCrud";
import { Slice, callTypes } from "./userSlice";

const { actions } = Slice;


export const getUsers = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUsers()
    .then((response) => {
      dispatch(actions.getUsers(response.data));
      return response.data;
    })
    .catch((error) => {
      const err =
        error?.response?.data?.message ||
        error.message ||
        "Kullanıcılar alınamadı.";
      dispatch(actions.catchError({ err, callType: callTypes.list }));
      return false;
    });
};


export const deleteUser = (data) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .deleteUser(data._id)
    .then((response) => {
      
      return response.data.state;
    })
    .catch((error) => {
      const err =
        error?.response?.data?.message ||
        error.message ||
        "Kullanıcı silinirken hata oluştu.";
      dispatch(actions.catchError({ err, callType: callTypes.list }));
      return false;
    });
};


export const editUser = (id, userData) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .editUser(id, userData)
    .then((response) => {
      
      dispatch(actions.editUser(response.data)); 
      return response.data;
    })
    .catch((error) => {
      const err =
        error?.response?.data?.message ||
        error.message ||
        "Kullanıcı güncellenemedi.";
      dispatch(actions.catchError({ err, callType: callTypes.action }));
      return false;
    });
};
